module.exports = __webpack_public_path__ + "assets/img/jining.a23f62d8.png";